import { setAccessToken, setStartTime } from "../core/localstorage-data"

export const sessionTimeHandler  = (accessToken?:string) =>
{
    if(accessToken)
    {
        setAccessToken(accessToken);
        
    }
    const currentDate = new Date();
    setStartTime(currentDate.toString());
}